import { redirectToHome } from './helpers';


const LIST_OF_RESTRICTED_PAGES = [
  '/media',
];

export const redirectToHomePageIfRestricted = (isSfw) => {
  if (LIST_OF_RESTRICTED_PAGES.includes(window.location.pathname) && isSfw) {
    redirectToHome();
  }
};
